export enum PropertySetTypes {
  AGENCY = 'AGENCY',
  TENANT_TOUR = 'TENANT_TOUR',
}
